module.exports = __webpack_public_path__ + "img/thumb-rusiandi.8aee547d.png";